query subjectsData($scenarioId: ID!, $originId: ID!, $filter: SubjectFilterInput) {
  data(scenarioId: $scenarioId, originId: $originId) {
    subjects(filter: $filter) {
      items {
        id
        code
        name
        __typename
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
    __typename
  }
}
